import { create } from 'zustand';

export interface PortalCustomer {
  id: number;
  email: string;
  customer_no: string | null;
  customer_type: 'B2C' | 'B2B' | null;
  first_name: string | null;
  last_name: string | null;
  company_name: string | null;
  preferred_language: string;
  status: string;
  last_login_at: string | null;
  display_name: string;
  // #406 — read-only profile data
  phone?: string | null;
  billing_address?: {
    street: string | null;
    street_2: string | null;
    postal_code: string | null;
    city: string | null;
    province: string | null;
    country: string | null;
  };
  // #406 — GDPR/LOPDGDD consent visibility
  privacy_policy_accepted?: boolean;
  privacy_policy_accepted_at?: string | null;
  privacy_policy_version?: string | null;
  marketing_consent?: boolean;
  marketing_consent_at?: string | null;
}

interface PortalAuthState {
  customer: PortalCustomer | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  isInitialized: boolean;
  error: string | null;

  setCustomer: (customer: PortalCustomer | null) => void;
  setLoading: (loading: boolean) => void;
  setInitialized: (initialized: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

const initialState = {
  customer: null,
  isAuthenticated: false,
  isLoading: false,
  isInitialized: false,
  error: null,
};

/**
 * Bundle K Phase K1D — Zustand store for the customer portal auth flow.
 * Lives separate from `useAuthStore` so the admin SPA's session state
 * never leaks into the portal context (and vice versa).
 */
export const usePortalAuthStore = create<PortalAuthState>((set) => ({
  ...initialState,

  setCustomer: (customer) =>
    set({
      customer,
      isAuthenticated: !!customer,
      error: null,
    }),

  setLoading: (isLoading) => set({ isLoading }),

  setInitialized: (isInitialized) => set({ isInitialized }),

  setError: (error) => set({ error }),

  reset: () => set(initialState),
}));
